var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page",attrs:{"id":"login"}},[(_vm.noAuth)?_c('CustomAlert',{attrs:{"type":"error","content":"Please login to access to Charlie's website"}}):_vm._e(),_c('TheLogin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }